export default {
  ar() {
    return {
      instructions: 'تم شحن حزمة التذاكر الخاصة بك بواسطة شركة {carrier}. إضغط على ارقام التتبع الموجودة بالأسفل لتتبع حزمتك.',
      orderShipments: 'تم شحن حزمة التذاكر الخاصة بك',
    }
  },
  de() {
    return {
      instructions: 'Ihr Paket wurde per {carrier} verschickt. Bitte klicken Sie auf die nachfolgende Trackingnummer(n) um Ihre Sendung zu verfolgen.',
      orderShipments: 'Ihr Paket wurde versendet',
    }
  },
  en() {
    return {
      instructions: 'Your package has been shipped via {carrier}. Click on the tracking number(s) below to track your package.',
      orderShipments: 'Your Package Has Shipped',
    }
  },
  enGB() {
    return {
      instructions: 'Your package has been shipped via {carrier}. Click on the tracking number(s) below to track your package.',
      orderShipments: 'Your Package Has Shipped',
    }
  },
  esMX() {
    return {
      instructions: 'Su paquete ha sido enviado vía {carrier}. Haga clic en el número(s) de rastreo a continuación para rastrear su paquete.',
      orderShipments: 'Su Paquete Ha Sido Enviado',
    }
  },
  fr() {
    return {
      instructions: 'Votre pack a été envoyé via {carrier}. Cliquez sur le(s) numéro(s) de suivi de votre pack pour suivre son acheminement.',
      orderShipments: 'Votre pack a été envoyé',
    }
  },
  it() {
    return {
      instructions: 'Il tuo pacchetto è stato spedito tramite {carrier}. Clicca sul numero di tracciamento sottostante se desideri monitorare il tuo pacchetto.',
      orderShipments: 'Il tuo pacchetto è stato spedito',
    }
  },
  ja() {
    return {
      instructions: 'お客様のパッケージは {carrier} で発送されました。パッケージの配送状況を確認するには下の追跡番号をクリックしてください。',
      orderShipments: 'あなたのパッケージが発送されました',
    }
  },
  pl() {
    return {
      instructions: 'Twój pakiet został wysłany za pośrednictwem {carrier}. Kliknij w numer(y) przesyłki, żeby ją śledzić.',
      orderShipments: 'Wysłaliśmy Twój pakiet',
    }
  },
  zhCN() {
    return {
      instructions: '您的套餐已通过{carrier}寄送。点击以下物流跟踪编号即可跟踪套餐信息。',
      orderShipments: '您的套餐已寄送',
    }
  }
}
